export const systemFontStack = {
  mono: 'Menlo, Consolas, Monaco, Liberation Mono, Lucida Console, monospace',
  sansSerif:
    '-apple-system, BlinkMacSystemFont, avenir next, avenir, segoe ui, helvetica neue, helvetica, Cantarell, Ubuntu, roboto, noto, arial, sans-serif',
  serif:
    'Iowan Old Style, Apple Garamond, Baskerville, Times New Roman, Droid Serif, Times, Source Serif Pro, serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
} as const;

export type SystemFontStack = keyof typeof systemFontStack;
